import { Injectable } from '@angular/core';
import { TipoEntregas } from '../shared/Util';

@Injectable({
  providedIn: 'root'
})
export class PopupDetalhesPedidoService {

  mostrarPopDetalhesPedido = false;
  chaveAcesso: string = null;
  motivoColeta: string | null = null;

  detalhesPedidos = [];
  constructor() { }  
  atualizaDetalhesPedidos(lista){
    this.detalhesPedidos = lista;
  }
}
